module.exports = __webpack_public_path__ + "img/alaska.a005a048.png";